import { IStatsigExperiment } from '@src/experiments/experiments.types'

export enum STATSIG_EXPERIMENTS {
  CTL_A_VS_A_EXPERIMENT = 'ctla-v-a',
  BANNER_A_CLP_A_V_A_EXPERIMENT = 'banner-a-clp-a-v-clp-a',
  EXPRESS_CHECKOUT_IN_CART = 'express-checkout-in-cart',
  SECOND_RETURNS_CHARGING = 'second-returns-charging',
  REDUCED_CART_SPACING = 'reduced-cart-spacing',
  BUY_NOW_BUTTON_PDP = 'buy-now-button-pdp',
  CONTACT_US_LINK_EXPERIMENT = 'contact-us-link',
  TRACKING_PAGE_CONTACT_US = 'tracking-page-contact-us',
  CLP_SORT = 'clp_sorting_a_vs_b_vs_c',
  CLP_SORT_V2 = 'clpv2_with_iss',
  TESTING_A_A_A = 'testing_a_a_a_exp',
  EDD = 'edd',
  TRUSTARC_CCM = 'trusarc-ccm',
  URGENCY_TAGS = 'urgency-tags',
  ORDER_DETAILS = 'ecom-featurerollout-web-orders-revamp',
  NEW_MOBILE_NAV = 'mweb_nav_design',
  SAVE_PARTIAL_CHECKOUT = 'save-partial-checkout',
  NEW_SEARCH_SUGGESTIONS = 'new_search_suggestions',
  PERSONALISED_EXPLORE_EVERYTHING = 'personalized-explore-everything',
  FEATURE_SECTION_2_DESIGN = 'feature-section-2-design',
  CHECKOUT_BANNER_CRO = 'checkout-banner-cro',
  CLP_PERSONALIZED = 'clp-personalized',
  CHECKOUT_PRELOAD = 'checkout-preload',
  PERSONALIZED_BESTSELLER = 'personalized-bestseller',
}

export const STATSIG_EXPERIMENTS_CONFIG: Record<STATSIG_EXPERIMENTS, IStatsigExperiment> = {
  [STATSIG_EXPERIMENTS.BUY_NOW_BUTTON_PDP]: {
    experimentName: 'buy-now-button-pdp',
    defaultBucket: 'Control', // Show, Control
  },
  [STATSIG_EXPERIMENTS.CTL_A_VS_A_EXPERIMENT]: {
    experimentName: 'ctla-v-a',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.BANNER_A_CLP_A_V_A_EXPERIMENT]: {
    experimentName: 'banner-a-clp-a-v-clp-a',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.SECOND_RETURNS_CHARGING]: {
    experimentName: 'second-returns-charging',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.REDUCED_CART_SPACING]: {
    experimentName: 'reduced-cart-spacing',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.EXPRESS_CHECKOUT_IN_CART]: {
    experimentName: 'express-checkout-in-cart',
    defaultBucket: 'control',
    buckets: {
      testA: 'testA',
      testB: 'testB',
      control: 'control',
    },
  },
  [STATSIG_EXPERIMENTS.CONTACT_US_LINK_EXPERIMENT]: {
    experimentName: 'contact-us-link',
    defaultBucket: 'Control',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.CLP_SORT]: {
    experimentName: 'clp_sorting_a_vs_b_vs_c',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.CLP_SORT_V2]: {
    experimentName: 'clpv2_with_iss',
    buckets: {
      control: 'control',
      groupA: 'groupA',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.TESTING_A_A_A]: {
    experimentName: 'testing_a_a_a_exp',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.EDD]: {
    experimentName: 'edd',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },
  [STATSIG_EXPERIMENTS.TRUSTARC_CCM]: {
    experimentName: 'trusarc-ccm',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.URGENCY_TAGS]: {
    experimentName: 'urgency-tags',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },
  [STATSIG_EXPERIMENTS.ORDER_DETAILS]: {
    experimentName: STATSIG_EXPERIMENTS.ORDER_DETAILS,
    defaultBucket: 'Control',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.NEW_MOBILE_NAV]: {
    experimentName: 'mweb_nav_design',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.SAVE_PARTIAL_CHECKOUT]: {
    experimentName: 'save-partial-checkout',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      Test: 'Test',
    },
  },
  [STATSIG_EXPERIMENTS.NEW_SEARCH_SUGGESTIONS]: {
    experimentName: 'new_search_suggestions',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.PERSONALISED_EXPLORE_EVERYTHING]: {
    experimentName: 'personalized-explore-everything',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.FEATURE_SECTION_2_DESIGN]: {
    experimentName: 'feature-section-2-design',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },
  [STATSIG_EXPERIMENTS.CHECKOUT_BANNER_CRO]: {
    experimentName: 'checkout-banner-cro',
    defaultBucket: 'control',
    buckets: {
      Control: 'Control',
      ShowA: 'ShowA',
      ShowB: 'ShowB',
    },
  },
  [STATSIG_EXPERIMENTS.TRACKING_PAGE_CONTACT_US]: {
    experimentName: 'tracking-page-contact-us',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      Experiment: 'Experiment',
    },
  },
  [STATSIG_EXPERIMENTS.CLP_PERSONALIZED]: {
    experimentName: 'clp-personalized',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.CHECKOUT_PRELOAD]: {
    experimentName: 'checkout-preload',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      Show: 'Show',
    },
  },
  [STATSIG_EXPERIMENTS.PERSONALIZED_BESTSELLER]: {
    experimentName: 'personalized-bestseller',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
}
